import { globalFeedEvents } from "../globalFeed"
import ADSBMarkerSet from "./adsbMarkerSet"
import { airTrafficMarker } from "./airTrafficeMarker"

const GLOBAL_CLEANUP_INTERVAL = 10 * 1000 // 10s
const MAX_LAST_SEEN = 60 * 1000 // 1m

let markerSet

export function hide() {
  markerSet.layer.removeFrom(mymap)
}

export function show() {
  markerSet.layer.addTo(mymap)
}

export function setup(feed) {
  markerSet = new ADSBMarkerSet("ADSB", {maxLastSeen:MAX_LAST_SEEN}, globalOverlay)

  globalFeedEvents.addEventListener("AIR_TRAFFIC", (ev) => {
    markerSet.update(ev.detail)
  })

  cleanup()
  show()
}

function cleanup() {
  markerSet.clean(Date.now())
  setTimeout(cleanup, GLOBAL_CLEANUP_INTERVAL)
}